<form class="routed-component-layout" [formGroup]="form" novalidate>

  <div class="routed-component-body">

    <div class="routed-component-title-block">
      <h2>{{'REGISTRATION.EXPECTED_ACTIVITY_STEP.CARDS.TITLE' | translate}}</h2>
      <h5>{{'REGISTRATION.EXPECTED_ACTIVITY_STEP.CARDS.SUB_TITLE' | translate}}</h5>
    </div>

    <div class="callout informative">
      <div class="callout-content">
        <p>{{'REGISTRATION.EXPECTED_ACTIVITY_STEP.CARDS.TIP_TEXT' | translate}}</p>
      </div>
    </div>
    <soldo-field-layout *ngIf="form.get('numberOfCards')"
      [control]="form.controls['numberOfCards']"
      fieldName="numberOfCards"
      cypressSelector="Expected_RadioButton_NumberOfCards"
      label="REGISTRATION.EXPECTED_ACTIVITY_STEP.CARDS.LABEL">

      <fieldset input>
        <div *ngFor="let option of numberOfCardsOptions; let i = index" class="radio-item"
          [attr.data-cy]="'Expected_RadioButton_NumberOfCards_'+option.value">
          <input type="radio" formControlName="numberOfCards" name="numberOfCards" [id]="'numberOfCardsOption'+i" [value]="option.value">
          <label [for]="'numberOfCardsOption'+i">{{ option.label }}</label>
        </div>
      </fieldset>

      <ng-container errorMessage>
        <soldo-field-error error errorName="required">{{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.CARDS.RANGE_REQUIRED' | translate }}</soldo-field-error>
      </ng-container>
    </soldo-field-layout>
  </div>

  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()" data-cy="Expected_Button_PreviousStepButton">
        {{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>
      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}"
      (click)="nextStep()" data-cy="Expected_Button_NextStepButton">{{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.NEXT_SUB_STEP_BUTTON' | translate }}</button>
    </div>
    <save-and-continue-later stepName="Expected Number of Cards"></save-and-continue-later>
  </div>

</form>

